var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Header'),_vm._v(" "),_c('BoosterClub'),_vm._v(" "),_c('Price'),_vm._v(" "),_c('Ability'),_vm._v(" "),_c('Faq'),_vm._v(" "),_c('Hero')],1)}
var staticRenderFns = []

export { render, staticRenderFns }